import styled, { keyframes } from 'styled-components';

export interface LoadingContainerProps {
  isLoading?: boolean;
  isIframeLoading?: boolean;
  isModal?: boolean;
}

export const Container = styled.div<LoadingContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ isLoading }) => isLoading && 'center'};
  height: ${({ isIframeLoading, isModal }) => (isIframeLoading || isModal ? '100%' : '100vh')};
  align-items: center;
  gap: 80px;
`;

export const slide = () => keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const reverseSlide = () => keyframes`
  50% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(100%);
  }
`;
